@app.service 'formHelper', ->

  # Shows an error for a form field
  @showErrorFor = (form, fieldName, validationParam) ->
    if form.$submitted || form[fieldName]?.$touched
      if form[fieldName].$error[validationParam]
        true

  this
